// extracted by mini-css-extract-plugin
export default {"formContainer":"Testimonals_formContainer__KsIvg"};